import * as React from "react";
import { FormFieldEntitySelect } from "../elements/form-field-entity-select";
import { FormFieldEntitySelectMultiple } from "../elements/form-field-entity-select-multiple";
import { FormFieldHidden } from "../elements/form-field-hidden";
import { FormFieldMarkdownEditor } from "../elements/form-field-markdown-editor";
import { FormFieldJsonEditor } from "../elements/form-field-json-editor";
import { FormFieldCheckbox } from "../elements/form-field-checkbox";
import { FormFieldNumber, FormFieldNumberInt } from "../elements/form-field-number";
import { FormFieldDate } from "../elements/form-field-date";
import { FormFieldDatetime } from "../elements/form-field-datetime";
import { FormFieldFile } from "../elements/form-field-file";
import { FormFieldImage } from "../elements/form-field-image";
import { FormFieldText, FormFieldTextArea } from "../elements/form-field-text";
import { createInheritedProvider } from "../utils/create-inherited-provider";
import { FormFieldLinkedJunction } from "../elements/form-field-linked-junction";
// Defines the default set of entity field types to form field control mapping
// A key design choice for V2 is that we want to be able to use the form field components
// in more lightweight scenarios, V1's code ended up being very all or nothing.
export var baseFormFieldComponentsDefinition = {
  hidden: FormFieldHidden,
  text: FormFieldText,
  textMultiple: FormFieldTextArea,
  longText: FormFieldMarkdownEditor,
  boolean: FormFieldCheckbox,
  int: FormFieldNumberInt,
  float: FormFieldNumber,
  date: FormFieldDate,
  json: FormFieldJsonEditor,
  datetime: FormFieldDatetime,
  image: FormFieldImage,
  file: FormFieldFile,
  linked: FormFieldEntitySelect,
  linkedMultiple: FormFieldEntitySelectMultiple,
  linkedJunction: FormFieldLinkedJunction
};
export var FormFieldComponentsContext = React.createContext(baseFormFieldComponentsDefinition);
export var FormFieldComponentsProvider = createInheritedProvider(FormFieldComponentsContext);